<p-blockui [blocked]="blocked">
  <div class="inner" *ngIf="blocked">
    <fa-icon [icon]="spinner" [spin]="true" [size]="size" [styles]="{'color':'#FAFAFA'}"></fa-icon>
    <br>
    <h1 *ngIf="header">{{header}}</h1>
    <p *ngIf="content">{{content}}</p>
  </div>
</p-blockui>
